// extracted by mini-css-extract-plugin
export var divider = "_q8-0";
export var systemMessage = "_q8-1";
export var systemMessageWrapper = "_q8-2";